import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const DotIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="4"
      height="4"
      viewBox="0 0 4 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="2" cy="2" r="2" fill="currentColor" />
    </BaseIcon>
  );
};

DotIcon.displayName = 'DotIcon';
